import { features } from '!/flags'
import { model as router } from '!/router'
import { PATH } from '@/constants'
import { createEvent, sample } from 'effector'
import { getLandingRegionUrlFromAlias } from '~/features/landingRegion'
import { preferencesFeatureModel } from '~/features/preferences'
import { $route } from '~/processes/navigation'

export const init = createEvent()

// Redirects if Live feature is not enabled
sample({
  clock: [$route, features.$liveFeatureEnabled],
  source: {
    route: $route,
    liveFeatureEnabled: features.$liveFeatureEnabled,
    preference: preferencesFeatureModel.$preference,
  },
  filter: ({ liveFeatureEnabled, route }) =>
    liveFeatureEnabled !== null &&
    !liveFeatureEnabled &&
    Boolean(route?.routeName?.includes(PATH.LIVE)),
  fn: ({ preference }) => {
    const landingRegion = preference?.alias
    return `${PATH.HOME}${landingRegion ? getLandingRegionUrlFromAlias(landingRegion) : ''}`
  },
  target: router.navigatePush,
})
